import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Popup } from 'components/Display/Popup/Popup';
import { Button } from 'components/Form/Button/Button';

type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const EditNoLongerPossibleModal: FC<Props> = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  const CancelButton = () => (
    <Button variant="secondary" onClick={onCancel} analyticsId="edit-message-state-changed-cancel">
      {t('webedi:editDocument.stateChangedDialog.cancel')}
    </Button>
  );

  const PrimaryButton = () => (
    <Button variant="primary" onClick={onConfirm} analyticsId="edit-message-state-changed-ok">
      {t('webedi:editDocument.stateChangedDialog.confirm')}
    </Button>
  );

  return (
    <Popup
      open={open}
      onClose={onCancel}
      title={t('webedi:editDocument.stateChangedDialog.title')}
      subtitle={t('webedi:editDocument.stateChangedDialog.description')}
      CancelButton={CancelButton}
      PrimaryButton={PrimaryButton}
    />
  );
};
